import styled from 'styled-components';

export default styled.div`
  position: relative;

  width: 100%;
  height: 100%;

  overflow: hidden;

  > .loading-container {
    position: absolute;

    width: 100%;
    height: 100%;

    background: white;

    > .loading {
      position: absolute;

      top: 50%;
      left: 50%;

      transform: translate(-50%, -50%);
    }
  }

  > .slide {
    position: absolute;

    width: 100%;
    height: 100%;

    > div {
      width: 100%;
      height: 100%;

      background-size: cover;
      background-position: center center;
    }

    &.over {
      overflow: hidden;
    }
  }

  > .dragger-container {
    position: absolute;

    width: 0.2rem;
    height: 100%;

    transform: translateX(-50%);

    background: rgba(0, 0, 0, 0.5);

    cursor: ew-resize;

    > .dragger {
      position: absolute;

      top: 50%;

      transform: translate(-1.9rem, -50%);

      width: 4rem;
      height: 4rem;

      background-color: #824cab;
      box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.5);
      border-radius: 50%;
    }
  }
`;
